var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"dashboard-container"},[_vm._v(" "+_vm._s(_vm.country)+" Hello ")])
}
var staticRenderFns = []

export { render, staticRenderFns }